import TaskSkeleton from "@/modules/tasks/components/tasks-view/task-skeleton";
import { Stack, useTheme } from "@mui/material";

const NextActionsSkeleton = () => {
  const theme = useTheme();

  return (
    <Stack direction="column" spacing={theme.nawy.spacing.md}>
      {/* Multiple loading tasks */}
      {[...Array(3)].map((_, index) => (
        <TaskSkeleton key={index} />
      ))}
    </Stack>
  );
};

export default NextActionsSkeleton;
